import { createReducer, on } from '@ngrx/store';
import * as actions from './path.actions';
import { PathData } from './path.data';

export const stateInitial: PathData = new PathData();

const _pathReducer = createReducer(stateInitial,
	on(actions.home, (state) => {
		const a = state.iComingFrom3D;
		state = stateInitial;
		return {
			...state,
			iComingFrom3D: a
		}
	 }),
	on(actions.goFront, (state, { path }) => {
		if (state.history.find(item => item === path) !== undefined) {
			return {
				...state
			}
		}
		return {
			...state,
			history: [path, ...state.history],
			path: path
		}
	}),
	on(actions.goBack, (state) => {
		if (state.history.length > 1) {
			//const _back = state.history[1];
			return {
				...state,
				history: state.history.slice(1, state.history.length),
				path: state.history[1]
			}
		}
		else {
			return {
				...state,
				path: state.history[0]
			}
		}
	}),
	on(actions.iComingFrom3D, (state) => {
		return {
			...state,
			iComingFrom3D: true
		}
	}),
	on(actions.iDontComingFrom3D, (state) => {
		return {
			...state,
			iComingFrom3D: false
		}
	}),
);

export function pathReducer(state, action) {
	return _pathReducer(state, action);
}
